const GA_MEASUREMENT_ID = 'G-W1HPDH9S8T';

export function initGA4() {
    if (!window.gtag) return;

    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
        send_page_view: false,
    });
}

export function gaPageView(path: string, title?: string) {
    if (!window.gtag) return;

    window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.href,
        page_title: title ?? document.title,
        send_to: GA_MEASUREMENT_ID,
    });
}

export function gaEvent(name: string, params?: Record<string, any>) {
    if (!window.gtag) return;
    window.gtag('event', name, params ?? {});
}